
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"10","viewBox":"0 0 12 10","fill":"#00A769","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"2","height":"2"}}),_c('rect',{attrs:{"x":"4","width":"8","height":"2"}}),_c('rect',{attrs:{"y":"4","width":"2","height":"2"}}),_c('rect',{attrs:{"x":"4","y":"4","width":"8","height":"2"}}),_c('rect',{attrs:{"y":"8","width":"2","height":"2"}}),_c('rect',{attrs:{"x":"4","y":"8","width":"8","height":"2"}})])
          )
        }
      }
    